// src/admin/pages/ShippingPage.jsx
import React, { useEffect, useState } from "react";
import { adminGetAllShippingFees, adminDeleteShippingFee } from "../api/admin";
import ShippingTable from "../components/ShippingTable";
import ShippingForm from "../components/ShippingForm";
import "./ShippingPage.css";

const ShippingPage = () => {
  const [fees, setFees] = useState([]);
  const [editingFee, setEditingFee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  
  // RBAC check
  const hasWritePermission = () => {
    const role = localStorage.getItem("adminRole");
    if (role === "admin") return true;
    const permissions = JSON.parse(localStorage.getItem("adminPermissions") || "[]");
    return permissions.includes("Shipping:write");
  };
  const canWrite = hasWritePermission();

  const clearEdit = () => {
    setEditingFee(null);
    setShowForm(false);
  };

  const fetchFees = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminGetAllShippingFees();
      const feesArray = Array.isArray(res.data) ? res.data : res.data?.fees ?? [];
      setFees(feesArray);
    } catch (err) {
      console.error("Error fetching shipping fees:", err);
      setError("Failed to load shipping fees");
      setFees([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFees();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this shipping fee?")) return;
    try {
      await adminDeleteShippingFee(id ?? id._id);
      fetchFees();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const handleEdit = (fee) => {
    setEditingFee(fee);
    setShowForm(true);
  };

  return (
    <div className="admin-page">
      {!showForm ? (
        <>
          <div className="page-header">
            <h2 className="adminproducts">Shipping Fees</h2>
            <div className="header-actions">
              {canWrite && (
                <button className="btn-add-product" onClick={() => { setEditingFee(null); setShowForm(true); }}>
                  + Add Shipping Fee
                </button>
              )}
            </div>
          </div>

          {loading && <p>Loading shipping fees...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {!loading && !error && (
            <ShippingTable
              fees={fees}
              onDelete={handleDelete}
              onEdit={handleEdit}
              canWrite={canWrite}
            />
          )}
        </>
      ) : (
        <>
          <div className="page-header">
            <div className="header-with-back">
              <button className="back-btn" onClick={clearEdit}>← Back</button>
              <h2 className="adminproducts">
                {editingFee ? "Update Shipping Fee" : "Create New Shipping Fee"}
              </h2>
            </div>
          </div>
          <div className="form-inline-container">
            <ShippingForm
              fee={editingFee}
              onSuccess={() => {
                clearEdit();
                fetchFees();
              }}
              onCancel={clearEdit}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ShippingPage;

